import 'react-phone-input-2/lib/style.css'
import WhyBlocks from './WhyBlocks'

export default function StartPage(props: any) {

    return (
        <div className="App start-page">
            <div className="start-page__side left">
                <div className='side-body'>
                    <div className="start-page__discount badge">
                        -20%
                    </div>
                    <div className="header">
                        Ремонт квартир в Москве и Московской области
                    </div>
                    <div className='subheader'>
                        Ответьте на несколько вопросов и получите 100%-точную смету на ремонт с материалом 👇
                    </div>
                    <button type="submit" onClick={props.toSite} id="show-price" className="button is-blicked questionnaire-navbar__button questionnaire-navbar__button_next">
                        Узнать стоимость
                    </button>
                    <div className="call-me-text call-me-text--why bonus">Почему нам доверяют?</div>
                    <WhyBlocks />
                </div>
                <div className="side-footer">
                    <a href="tel:+79854327045" target="_parent" className="">+7 985 432-70-45</a>
                </div>
            </div>
            <div className="start-page__side">
                <div className='right-side--bg'></div>
            </div>
        </div>
    )
}
